import { useMemo } from 'react';

import { useAccessToken } from '../auth/use-access-token';
import type { TokenAccessor } from '../services/base';

// Builds a service outside the router's context — for pages and admin views
// that are not scoped to a store, and so cannot read one off
// storeLayout.useRouteContext(). Everything inside a store route should take
// its services from route context instead, so the whole page shares one
// instance.
export function useService<T>(Service: new (tokenAccessor: TokenAccessor) => T): T {
  const getAccessTokenSilently = useAccessToken();

  return useMemo(() => new Service(getAccessTokenSilently), [Service, getAccessTokenSilently]);
}
